<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">Marketing</h1>
  <p class="form-desc">
    Brand assets, templates, and resources for marketing Landpoint's surveying services.
  </p>
</div>
<br>

<mat-card class="mat-mdc-elevation-specific mat-elevation-z8">
  <mat-card-content>
    <div class="home-row">
      <a
        mat-stroked-button
        class="marketing-home-btn"
        [href]="marketingHomeUrl"
        target="_blank"
        rel="noopener"
      >
        <mat-icon>open_in_new</mat-icon>
        Marketing Home on SharePoint
      </a>
    </div>

    @if (forms.length) {
      <h2 class="section-title">Forms</h2>
      <div class="link-grid">
        @for (item of forms; track item.url) {
          <a class="link-tile" [href]="item.url" target="_blank" rel="noopener">
            <mat-icon class="tile-icon">{{ item.icon }}</mat-icon>
            <span class="tile-label">{{ item.label }}</span>
          </a>
        }
      </div>
    }

    <h2 class="section-title">Resources</h2>
    <div class="link-grid">
      @for (item of resources; track item.url) {
        <a class="link-tile" [href]="item.url" target="_blank" rel="noopener">
          <mat-icon class="tile-icon">{{ item.icon }}</mat-icon>
          <span class="tile-label">{{ item.label }}</span>
        </a>
      }
    </div>
  </mat-card-content>
</mat-card>
